module.exports = __webpack_public_path__ + "img/pet-art.2602ef92.webp";